import {useMemo} from 'react'
import get from 'lodash/get'
import useUserContext from './useUserContext'

export default function useUserPermissions() {
  const {value: user, loading} = useUserContext()
  const isAdmin = !!get(user, 'permissions.admin', false)
  const isPartner = !!get(user, 'partnerId')

  return useMemo(
    () => ({isAdmin, isPartner, user, loading}),
    [isAdmin, isPartner, user, loading]
  )
}
